<div class="w-full relative">
  @let notOperated = notOperatedByLla$ | async;
  @if (notOperated || showCloseButton) {
    <div
      class="flex items-center justify-between w-full px-2xl py-base text-sm leading-sm"
      [ngClass]="notOperated ? 'bg-error/10 text-error-dark font-semibold' : 'text-txt-secondary'"
    >
      <span [class.invisible]="!notOperated" [attr.aria-hidden]="!notOperated">Not operated by LLA</span>
      @if (showCloseButton) {
        <svg-icon
          key="close"
          class="text-2xs! cursor-pointer"
          (click)="invoiceInfoClosed.emit()"
        ></svg-icon>
      }
    </div>
  }

  <div class="p-2xl">
    @if (!isLoading) {
      @if (invoiceResponse$ | async; as info) {
        @if (forModal && info.invoice && info.invoice.locationName) {
          <div class="-mt-base pb-sm text-txt font-semibold">
            {{ info.invoice.locationName }}
          </div>
        }
        <!-- Invoice Number -->
        <div class="flex flex-col md:flex-row md:items-center w-full text-white bg-primary px-sm py-xs">
          <div class="flex-1 flex items-center font-semibold text-sm leading-sm">
            <div>Invoice: {{ info.invoice.invoiceNumber }}</div>
            <div
              (click)="commonService.copyToClipboard(info.invoice.invoiceNumber.toString(), 'Invoice number copied')"
              class="flex pl-sm cursor-pointer"
            >
              <svg-icon class="text-xs!" key="file-copy"></svg-icon>
            </div>
          </div>
          @if (forModal && info.contact && info.contact.contactId !== emptyGuid) {
            <a
              class="flex-1 cursor-pointer text-sm leading-sm font-semibold"
              target="_blank"
              [href]="
                websiteUrl + '/contacts/detail/' + info.contact.contactId + '/invoice/' + invoiceId
              "
            >
              @if (info.contact.company) {
                <span>
                  {{ info.contact.company }}
                </span>
              }
              @if (
                info.contact.company &&
                info.contact.company !== '' &&
                ((info.contact.firstName && info.contact.firstName !== '') ||
                  (info.contact.lastName && info.contact.lastName !== ''))
              ) {
                <span> - </span>
              }
              <span class="mr-sm">{{ info.contact.firstName }}</span>
              <span>{{ info.contact.lastName }}</span>
            </a>
          }
        </div>
        <!-- Base Info -->
        <div class="mt-base flex flex-col md:flex-row">
          @if (info.invoice; as baseInfo) {
            <div class="flex-1">
              <div class="base-info-item">
                Date: {{ baseInfo.invoiceTime | date: 'MMM d, yyyy, h:mm a' }}
              </div>
              <div class="base-info-item">Work Order #: {{ baseInfo.workOrder }}</div>
              <div class="base-info-item">Service Advisor: {{ baseInfo.serviceAdvisor }}</div>
              <div class="base-info-item">Technician: {{ baseInfo.technician }}</div>
            </div>
          }
          @if (info.vehicle; as vehicle) {
            <div class="flex-1 pt-xs md:pt-0">
              <div class="base-info-item">Plate: {{ vehicle.plate }}</div>
              <div class="base-info-item">Description: {{ vehicle.description }}</div>
              <div class="base-info-item">Vin: {{ vehicle.vin }}</div>
              <div class="base-info-item">Odometer: {{ vehicle.odometer }}</div>
            </div>
          }
        </div>
        <!-- Concern -->
        @if (info.concern; as concerns) {
          <div class="section-title text-error border-error">Concern</div>
          <div>
            @for (item of concerns; track item) {
              <ng-container
                *ngTemplateOutlet="servicePackageItem; context: { item: item }"
              ></ng-container>
            }
          </div>
        }
        <!-- Service -->
        @if (info.service; as services) {
          <div class="section-title text-primary border-primary">Service</div>
          <div>
            @for (item of services; track item) {
              <ng-container
                *ngTemplateOutlet="servicePackageItem; context: { item: item }"
              ></ng-container>
            }
          </div>
        }
        <!-- Inspection -->
        @if (info.inspection; as inspection) {
          <div class="section-title text-primary border-primary">Inspection</div>
          <div>
            @for (item of inspection; track item) {
              <ng-container
                *ngTemplateOutlet="servicePackageItem; context: { item: item }"
              ></ng-container>
            }
          </div>
        }
        <!-- General Credits -->
        @if (info.generalCredits; as generalCredits) {
          <div class="section-title text-primary border-primary">General Credits</div>
          <div>
            @for (item of generalCredits; track item) {
              <ng-container
                *ngTemplateOutlet="servicePackageItem; context: { item: item }"
              ></ng-container>
            }
          </div>
        }
        <!-- Deferred Service -->
        @if (info.deferredService; as deferredService) {
          <div class="section-title text-primary border-primary">Deferred Service</div>
          <div>
            @for (item of deferredService; track item) {
              <ng-container
                *ngTemplateOutlet="servicePackageItem; context: { item: item }"
              ></ng-container>
            }
          </div>
        }
        <!-- Deferred Concern -->
        @if (info.deferredConcern; as deferredConcern) {
          <div class="section-title text-primary border-primary">Deferred Concern</div>
          <div>
            @for (item of deferredConcern; track item) {
              <ng-container
                *ngTemplateOutlet="servicePackageItem; context: { item: item }"
              ></ng-container>
            }
          </div>
        }
        <!-- Deferred Inspection -->
        @if (info.deferredInspection; as deferredInspection) {
          <div class="section-title text-primary border-primary">Deferred Inspection</div>
          <div>
            @for (item of deferredInspection; track item) {
              <ng-container
                *ngTemplateOutlet="servicePackageItem; context: { item: item }"
              ></ng-container>
            }
          </div>
        }
        <!-- Grand total -->
        @if (info.summary; as summary) {
          <div class="section-title text-primary border-primary">Grand total</div>
          <div>
            <table class="w-full mt-lg">
              <tr class="grand-total-row">
                <td>Total Parts</td>
                <td>{{ summary.partsTotalFormatted }}</td>
              </tr>
              <tr class="grand-total-row">
                <td>Total Labor</td>
                <td>{{ summary.laborTotalFormatted }}</td>
              </tr>
              <tr
                class="grand-total-row"
                [class.cursor-pointer]="summary.otherCharges.length"
                (click)="summary.otherCharges.length && (otherChargesExpanded = !otherChargesExpanded)"
              >
                <td>
                  <span class="inline-flex items-center gap-xs">
                    Other Charges
                    @if (summary.otherCharges.length) {
                      <svg-icon
                        key="arrow-down-simple"
                        class="text-2xs! transition-transform"
                        [class.rotate-180]="otherChargesExpanded"
                      ></svg-icon>
                    }
                  </span>
                </td>
                <td>{{ summary.otherChargeTotalFormatted }}</td>
              </tr>
              @if (otherChargesExpanded) {
                @for (line of summary.otherCharges; track line) {
                  <tr class="grand-total-row">
                    <td class="font-normal! pl-2xl! text-txt-secondary">
                      <span class="mr-sm">{{ line.code }}</span>{{ line.name }}
                    </td>
                    <td class="font-normal! text-txt-secondary">{{ line.amountFormatted }}</td>
                  </tr>
                }
              }
              <tr
                class="grand-total-row"
                [class.cursor-pointer]="summary.surchargeFees.length"
                (click)="summary.surchargeFees.length && (surchargeFeesExpanded = !surchargeFeesExpanded)"
              >
                <td>
                  <span class="inline-flex items-center gap-xs">
                    Surcharge Fee
                    @if (summary.surchargeFees.length) {
                      <svg-icon
                        key="arrow-down-simple"
                        class="text-2xs! transition-transform"
                        [class.rotate-180]="surchargeFeesExpanded"
                      ></svg-icon>
                    }
                  </span>
                </td>
                <td>{{ summary.surchargeFeeFormatted }}</td>
              </tr>
              @if (surchargeFeesExpanded) {
                @for (line of summary.surchargeFees; track line) {
                  <tr class="grand-total-row">
                    <td class="font-normal! pl-2xl! text-txt-secondary">
                      <span class="mr-sm">{{ line.code }}</span>{{ line.name }}
                    </td>
                    <td class="font-normal! text-txt-secondary">{{ line.amountFormatted }}</td>
                  </tr>
                }
              }
              <tr class="grand-total-row">
                <td>Total Without TAX</td>
                <td>{{ summary.totalWithoutTaxFormatted }}</td>
              </tr>
              <tr
                class="grand-total-row"
                [class.cursor-pointer]="summary.taxes.length"
                (click)="summary.taxes.length && (taxesExpanded = !taxesExpanded)"
              >
                <td>
                  <span class="inline-flex items-center gap-xs">
                    Taxes
                    @if (summary.taxes.length) {
                      <svg-icon
                        key="arrow-down-simple"
                        class="text-2xs! transition-transform"
                        [class.rotate-180]="taxesExpanded"
                      ></svg-icon>
                    }
                  </span>
                </td>
                <td>{{ summary.taxTotalFormatted }}</td>
              </tr>
              @if (taxesExpanded) {
                @for (line of summary.taxes; track line) {
                  <tr class="grand-total-row">
                    <td class="font-normal! pl-2xl! text-txt-secondary">
                      <span class="mr-sm">{{ line.code }}</span>{{ line.name }}
                    </td>
                    <td class="font-normal! text-txt-secondary">{{ line.amountFormatted }}</td>
                  </tr>
                }
              }
              <tr class="total-row">
                <td class="font-semibold! text-txt! px-sm">Grand Total</td>
                <td class="font-semibold! text-txt! text-right px-sm">
                  {{ summary.grandTotalFormatted }}
                </td>
              </tr>
            </table>
          </div>
        }
      }
    } @else {
      <div class="flex justify-center mt-lg">
        <mat-progress-spinner [diameter]="80" mode="indeterminate"></mat-progress-spinner>
      </div>
    }
  </div>
</div>

<ng-template #servicePackageItem let-item="item">
  <div class="mt-base last:pb-0">
    <div class="font-semibold text-sm leading-sm">{{ item.header }}</div>
    @if (item.description) {
      <div class="mt-xs text-sm leading-sm text-txt">
        {{ item.description }}
      </div>
    }
    <div title="" class="w-full overflow-x-auto beautyScroll">
      @if (item.lines && item.lines.length > 0) {
        <table class="w-max md:w-full mt-base">
          @for (line of item.lines; track line) {
            <tr>
              <td class="max-w-[200px] md:max-w-[auto] md:w-1/2 px-sm">
                {{ line.description }}
              </td>
              <td class="text-right">
                @if (line.quantity !== undefined && line.quantity !== null) {
                  <div class="pl-sm pr-[3px]">
                    {{ line.quantity }}
                  </div>
                }
              </td>
              <td class="p-0">
                @if (line.priceUnit && line.priceUnit !== '') {
                  <div class="pr-sm w-max">/ {{ line.priceUnit }}</div>
                }
              </td>
              <td class="text-right">
                @if (line.priceFormatted) {
                  <div class="pl-sm pr-[3px]">
                    {{ line.priceFormatted }}
                  </div>
                }
              </td>
              <td class="p-0">
                @if (line.priceUnit && line.priceUnit !== '') {
                  <div class="pr-sm w-max">/ {{ line.priceUnit }}</div>
                }
              </td>
              <td class="text-right">
                @if (line.totalFormatted) {
                  <div class="px-sm">
                    {{ line.totalFormatted }}
                  </div>
                }
              </td>
              <td class="w-0 p-0">
                @if (line.totalFormatted && line.otherChargeCode && line.otherChargeCode !== '') {
                  <div class="pr-sm">
                    {{ line.otherChargeCode }}
                  </div>
                }
              </td>
            </tr>
          }
          @if (item.subTotalDiscountFormatted && item.subTotalDiscountFormatted !== '$0.00') {
            <tr class="total-row">
              <td class="font-semibold! text-error-dark! px-sm">Discount</td>
              <td colspan="5" class="font-semibold! text-error-dark! text-right px-sm">
                ({{ item.subTotalDiscountFormatted }})
              </td>
              <td></td>
            </tr>
          }
          <tr class="total-row">
            <td class="font-semibold! text-txt! px-sm">Sub total</td>
            <td colspan="5" class="font-semibold! text-txt! text-right px-sm">
              {{ item.subTotalFormatted }}
            </td>
            <td></td>
          </tr>
        </table>
      }
    </div>
  </div>
</ng-template>
